import { Component } from '@angular/core';

@Component({
  selector: 'app-video-loading',
  templateUrl: './video-loading.component.html',
  styleUrls: ['./video-loading.component.css']
})
export class VideoLoadingComponent { }
